import React from 'react';
import DefaultLayout from '../../layouts/default';
import SensorDetailsHeader from './components/SensorDetailsHeader';
import SensorInfoSummary from './components/SensorInfoSummary';
import EquipmentHealth from './components/EquipmentHealth';
import CoolingPerformance from './components/CoolingPerformance';
import TemperatureStability from './components/TemperatureStability';
import TodayAiSummary from './components/TodayAiSummary';
import TemperatureTrendToday from './components/TemperatureTrendToday';
import RecentActivity  from './components/RecentActivity';
import EquipmentSpecsAndPrediction  from './components/EquipmentSpecsAndPrediction';
import DetailFooterActions  from './components/DetailFooterActions';

const SensorPage = () => {
  return (
    <DefaultLayout>
       <SensorDetailsHeader />
       <SensorInfoSummary />
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 p-6 bg-[#FAF9F6]">
          <EquipmentHealth />
          <CoolingPerformance />
          <TemperatureStability />
          <TodayAiSummary />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 p-6 bg-[#FAF9F6]">
          <TemperatureTrendToday />
          <RecentActivity />
          <EquipmentSpecsAndPrediction  />
        </div>
        <DetailFooterActions />
    </DefaultLayout>
  );
};

export default SensorPage;